import { __makeTemplateObject } from "tslib";
import React from 'react';
import { css, cx } from 'emotion';
import { VizLegendSeriesIcon } from './VizLegendSeriesIcon';
import { useStyles } from '../../themes/ThemeContext';
import { styleMixins } from '../../themes';
import { formattedValueToString } from '@grafana/data';
/**
 * @internal
 */
export var LegendTableItem = function (_a) {
    var item = _a.item, onSeriesColorChange = _a.onSeriesColorChange, onLabelClick = _a.onLabelClick, className = _a.className;
    var styles = useStyles(getStyles);
    return (React.createElement("tr", { className: cx(styles.row, className) },
        React.createElement("td", null,
            React.createElement("span", { className: styles.itemWrapper },
                React.createElement(VizLegendSeriesIcon, { disabled: !onSeriesColorChange, color: item.color, onColorChange: function (color) {
                        if (onSeriesColorChange) {
                            onSeriesColorChange(item.label, color);
                        }
                    } }),
                React.createElement("div", { onClick: function (event) {
                        if (onLabelClick) {
                            onLabelClick(item, event);
                        }
                    }, className: cx(styles.label, item.disabled && styles.labelDisabled) },
                    item.label,
                    " ",
                    item.yAxis === 2 && React.createElement("span", { className: styles.yAxisLabel }, "(right y-axis)")))),
        item.getDisplayValues &&
            item.getDisplayValues().map(function (stat, index) {
                return (React.createElement("td", { className: styles.value, key: stat.title + "-" + index }, formattedValueToString(stat)));
            })));
};
LegendTableItem.displayName = 'LegendTableItem';
var getStyles = function (theme) {
    var rowHoverBg = styleMixins.hoverColor(theme.colors.bg1, theme);
    return {
        row: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      label: LegendRow;\n      font-size: ", ";\n      border-bottom: 1px solid ", ";\n      td {\n        padding: ", " ", ";\n        white-space: nowrap;\n      }\n\n      &:hover {\n        background: ", ";\n      }\n    "], ["\n      label: LegendRow;\n      font-size: ", ";\n      border-bottom: 1px solid ", ";\n      td {\n        padding: ", " ", ";\n        white-space: nowrap;\n      }\n\n      &:hover {\n        background: ", ";\n      }\n    "])), theme.typography.size.sm, theme.colors.border1, theme.spacing.xxs, theme.spacing.sm, rowHoverBg),
        label: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      label: LegendLabel;\n      cursor: pointer;\n      white-space: nowrap;\n    "], ["\n      label: LegendLabel;\n      cursor: pointer;\n      white-space: nowrap;\n    "]))),
        labelDisabled: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      label: LegendLabelDisabled;\n      color: ", ";\n    "], ["\n      label: LegendLabelDisabled;\n      color: ", ";\n    "])), theme.colors.linkDisabled),
        itemWrapper: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      display: flex;\n      white-space: nowrap;\n      align-items: center;\n    "], ["\n      display: flex;\n      white-space: nowrap;\n      align-items: center;\n    "]))),
        value: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      text-align: right;\n    "], ["\n      text-align: right;\n    "]))),
        yAxisLabel: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.palette.gray2),
    };
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=VizLegendTableItem.js.map